import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import {
  DefaultEffects,
  IColumn,
  IDetailsListStyleProps,
  IDetailsListStyles,
  IStyleFunctionOrObject,
  Panel,
  PanelType,
  Stack,
  TextField,
} from "@fluentui/react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import {
  IDatoModeloEquipo,
  IPostCrearEquipo,
  initialPostCrearEquipo,
} from "../../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { useEquipos } from "../../../hooks/Equipos/useEquipos";
import { TableSelectRow } from "../../../components/Table/TableSelectRow";
import { useTableEquipoPorModelo } from "../../../hooks/TablasHooks/useTableEquipoPorModelo";
import { FooterTable } from "../../../components/Table/FooterTable";
import { TableBase } from "../../../components/Table/TableBase";
import { TableBase2 } from "../../../components/Table/TableBase2";
interface IPanelAddEquipoPorModelo {
  isOpen: boolean;
  onDismiss: () => void;
  datosModeloEquipo: IDatoModeloEquipo;
}

export const PanelAddEquipoPorModelo = (props: IPanelAddEquipoPorModelo) => {
  const styleTable: IStyleFunctionOrObject<
    IDetailsListStyleProps,
    IDetailsListStyles
  > = {
    root: {
      height: "calc(100vh - 9rem)",
    },
  };

  const {
    loading,
    dataTeble,
    paginacion,
    onClickNext,
    onClickPrevius,
    searchBoxRefTable,
    _onkeyUpSearch,
    onClickRefresh,
  } = useTableEquipoPorModelo(
    props.isOpen,
    props.datosModeloEquipo?.modeloEquipoId
  );

  const [request, setRequest] = useState<IPostCrearEquipo>(
    initialPostCrearEquipo
  );

  const { ocultarMensaje, response, isSend, postCrearEquipo } = useEquipos(onClickRefresh);

  const column: IColumn[] = [
    {
      key: "tipoEquipo",
      name: "Equipo",
      fieldName: "nombre",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "modelo",
      minWidth: 160,
      maxWidth: 160,
      isResizable: true,
    },
    {
      key: "horometro",
      name: "Horometro",
      fieldName: "horometro",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
  ];

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="add"
          textHeader={`Agregar Equipo`}
          subTextHeader={`Equipos del modelo ${props.datosModeloEquipo.nombreModelo} `}
        />
      </>
    ),
    [props.datosModeloEquipo]
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar Equipo"
          onClick={() => {
            postCrearEquipo(request);
          }}
          onDismiss={() => {
            props.onDismiss();
          }}
        />
      </>
    ),
    [postCrearEquipo, request]
  );
  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    valor?: string
  ) => {
    if (event !== undefined && valor !== undefined) {
      setRequest({
        ...request,
        nombre: valor,
        modeloId: props.datosModeloEquipo.modeloEquipoId,
      });
    }
  };

  useEffect(() => {
    if (!props.isOpen) {
      ocultarMensaje();
      setRequest(initialPostCrearEquipo);
    }
  }, [props.isOpen]);

  return (
    <Panel
      type={PanelType.custom}
      customWidth="600px"
      onRenderHeader={onRenderHeader}
      // onRenderFooter={onRenderFooter}
      isFooterAtBottom
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
    >
      <>
        <MensajeBar response={response} ocultar={() => { }} />
        {isSend == true ? (
          <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
        ) : (
          <div className="ms-Grid" dir="ltr">
            <div
              style={{
                margin: "30px 0px",
                width: "100%",
                height: "auto",
                padding: "15px 0px",
              }}
            >
              <div
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <TextField
                    label="Nombre del  Equipo:"
                    underlined
                    required
                    placeholder="Escribir aquí"
                    onChange={onChangeTextField}
                  />
                </div>
              </div>
              <div
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <br />
                <PanelFooter
                  texto="Agregar"
                  onClick={() => {
                    postCrearEquipo(request);
                  }}
                  onDismiss={() => {
                    props.onDismiss();
                  }}
                />
              </div>

              <Stack>
                <TableBase2
                  //leftBar={_items}
                  data={dataTeble}
                  column={column}
                  isLoading={loading}
                // footerPagination={
                //   <PaginationFooterC
                //     paginacion={paginacion}
                //     onChangePagina={(e) => {
                //       onChangeSkip(e);
                //     }}
                //   />
                // }
                />
              </Stack>

              <div
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "end",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <div
                    style={{
                      marginTop: "10x",
                      position: "relative",
                      overflow: "auto",
                      maxHeight: "calc(100vh - 300px)",
                    }}
                  >
                    {/* <TableSelectRow
                      loading={loading}
                      styles={styleTable}
                      columns={column}
                      items={dataTeble}
                      leftBar={[]}
                    /> */}
                    {/* <Stack>
                      <TableBase2
                        //leftBar={_items}
                        data={dataTeble}
                        column={column}
                        isLoading={loading}
                      // footerPagination={
                      //   <PaginationFooterC
                      //     paginacion={paginacion}
                      //     onChangePagina={(e) => {
                      //       onChangeSkip(e);
                      //     }}
                      //   />
                      // }
                      />
                    </Stack> */}

                  </div>
                  {/* <div style={{ margin: "10px", height: "50px" }}>
                    <FooterTable
                      onClickNext={onClickNext}
                      onClickPrevius={onClickPrevius}
                      TotalData={paginacion?.total}
                      PaginaActual={paginacion?.page}
                      TotalPagina={paginacion?.pages}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </Panel>
  );
};
